export const activityProgrammeLanguage = {
  title: 'Activity Programme',
  subtitle: 'Review, complete, certify and return Activity Plans across Cost Centers.',
  filtersTitle: 'Programme Filters',
  filtersSubtitle: 'Filter the current Planning Cycle programme by Cost Center, Strategic Axis and Plan State.',
  reviewTitle: "Programme d'Activités — Horizontal Review",
  currentPhaseCode: 'ACTIVITY PROGRAMME',
};

export default activityProgrammeLanguage;
